// extracted by mini-css-extract-plugin
export default {"drawerButton":"open-session-modal_drawerButton__GOVcH","drawerHint":"open-session-modal_drawerHint__V5MXH"};